import React, { useCallback, useEffect, useState } from 'react';
import { brokerApi } from './api';
import StockLink from './StockLink';

export default function Orders() {
  const [orders, setOrders] = useState(null);
  const [error, setError] = useState(null);
  const [cancelingId, setCancelingId] = useState(null);

  const load = useCallback(() => {
    brokerApi
      .orders('all')
      .then((data) => {
        setOrders(data);
        setError(null);
      })
      .catch((err) => setError(err.message));
  }, []);

  useEffect(() => {
    load();
    const interval = setInterval(load, 15000);
    return () => clearInterval(interval);
  }, [load]);

  const handleCancel = async (id) => {
    setCancelingId(id);
    try {
      await brokerApi.cancelOrder(id);
      load();
    } catch (err) {
      setError(err.message);
    } finally {
      setCancelingId(null);
    }
  };

  const isOpen = (status) => ['new', 'accepted', 'pending_new', 'partially_filled'].includes(status);

  return (
    <div className="module-container">
      <div className="module-header">
        <h2>Orders</h2>
        <p>Open and historical orders placed through your connected Alpaca account.</p>
      </div>

      {error && <div className="error-box">{error}</div>}

      <div className="dashboard-section">
        {!orders ? (
          <div className="skeleton-list">
            <span className="skeleton-bar" />
            <span className="skeleton-bar" />
          </div>
        ) : orders.length === 0 ? (
          <div className="empty-state">
            <p>No orders yet</p>
            <small>Head to "Trade" to place your first order</small>
          </div>
        ) : (
          <div className="orders-table">
            <div className="orders-table-header">
              <span>Symbol</span>
              <span>Side</span>
              <span>Qty</span>
              <span>Type</span>
              <span>Status</span>
              <span></span>
            </div>
            {orders.map((o) => (
              <div key={o.id} className="order-row">
                <StockLink symbol={o.symbol} className="holding-ticker" />
                <span>{o.side.toUpperCase()}</span>
                <span>{o.qty}</span>
                <span>{(o.order_type || o.type || '').replace(/_/g, ' ')}</span>
                <span>
                  <span className={`order-status ${o.status}`}>{o.status.replace(/_/g, ' ')}</span>
                </span>
                <span>
                  {isOpen(o.status) && (
                    <button className="cancel-order-button" onClick={() => handleCancel(o.id)} disabled={cancelingId === o.id}>
                      {cancelingId === o.id ? 'Canceling…' : 'Cancel'}
                    </button>
                  )}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
